<div class="d-flex justify-content-between gap-3 mb-3">
  @for (itemList of summaryItems; track itemList; let first = $first) {
    <app-report-value-pairs [summaryItems]="itemList" [labelMinWidth]="first"></app-report-value-pairs>
  }
</div>
